<div
	#bar
	class="composer-bar"
	*ngIf="barRendered"
	[class.composer-bar--compact]="compact"
	[class.composer-bar--awaiting]="awaitingArrival"
	[class.composer-bar--arriving]="arriving"
	[class.composer-bar--returning]="returning"
	[attr.inert]="leaving ? '' : null"
	(animationend)="onBarAnimationEnd($event)"
>
	<!--
		TRAP: one input in BOTH forms — the circle is this same shell, narrowed, with its
		content hidden. Two elements again and a navigation can only swap them, not morph.
	-->
	<app-ai-assistant-input
		#shell
		class="composer-input"
		[class.composer-compact]="compact"
		[class.composer-input--bare]="contentHidden"
		[control]="messageControl"
		[loading]="sending"
		sendMode="whenText"
		placeholder="Ask Ana about anything on this page"
		ariaLabel="Ask Ana"
		(send)="send()"
	>
		<app-icon
			aiInputLeading
			class="composer-leading"
			type="svg"
			[size]="20"
			aria-hidden="true"
		>
			ai_lolly_logo
		</app-icon>
		<span
			aiInputTrailing
			class="composer-divider"
			aria-hidden="true"
		></span>
		<div aiInputTrailing class="composer-toggle-slot">
			<div class="composer-toggle">
				<button
					lo-button
					variant="ghost"
					size="sm"
					iconOnly
					round
					type="button"
					class="composer-open"
					data-testid="ana-page-composer-open"
					[attr.aria-label]="openLabel"
					[loTooltip]="openLabel"
					loTooltipCompact
					loTooltipPlacement="top"
					(click)="open($event)"
				>
					<lo-icon name="bar_left"></lo-icon>
				</button>
				<typography
					*ngIf="badgeCount"
					variant="p/xxs_semibold"
					class="composer-toggle__badge"
					data-testid="ana-page-composer-badge"
					aria-hidden="true"
				>
					{{ badgeCount }}
				</typography>
			</div>
		</div>
	</app-ai-assistant-input>
</div>
